import { render, staticRenderFns } from "./rechargeBonus.vue?vue&type=template&id=1f0f1df2&scoped=true"
import script from "./rechargeBonus.vue?vue&type=script&lang=js"
export * from "./rechargeBonus.vue?vue&type=script&lang=js"
import style0 from "./rechargeBonus.vue?vue&type=style&index=0&id=1f0f1df2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f1df2",
  null
  
)

export default component.exports